import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  downloadHeader: {
    height: 30,
    margin: theme.spacing(5, 0, 2, 0),
    fontSize: 24,
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.25,
    letterSpacing: 'normal',
    color: theme.colorPalette.green_90
  },
  downloadLoader: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: theme.colorPalette.orange_50
  },
  pdfDownloadContainer: {
    padding: theme.spacing(4)
  },
  downloadButton: {
    width: '100%',
    cursor: 'pointer',
    '&:not(:last-child)': {
      marginBottom: theme.spacing(1)
    },
    ...reskinStyles(theme, theme.actionStyles.list)
  },
  downloadLabel: {
    alignItems: 'center',
    padding: theme.spacing(1),
    width: '100%',
    color: theme.colors.action_text,
    fontSize: 16,
    fontWeight: 500
  },
  iconContainer: {
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  }
}));

export default useStyles;
